export default {
  loading: false,
  downloads: []
}
